export interface StoredAuthState {
  backendAccessToken: string | null;
  tokenType: string | null;
  expiresIn: number | null;
  profile: any;
}

const STORAGE_KEY = 'auth_state_v1';

export const SessionManager = {
  load(): StoredAuthState | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as StoredAuthState) : null;
    } catch {
      return null;
    }
  },
  save(state: StoredAuthState) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {}
  },
  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
  },
  getAuthHeaders(): Record<string, string> {
    const state = this.load();
    if (state?.backendAccessToken) {
      return { Authorization: `Bearer ${state.backendAccessToken}` };
    }
    return {};
  },
};


